import {inject, Injectable, OnInit, signal} from '@angular/core';
import {Observable, of} from "rxjs";
import {UserData} from "../../generated-model/model";
import {tap} from "rxjs/operators";
import {UserDataResource} from "../shared/service/UserDataResource";

@Injectable({
    providedIn: 'root'
})
export class UserDataService implements OnInit {
    private userDataResource = inject(UserDataResource);
    private userData = signal<UserData>(undefined);

    constructor() {
    }

    ngOnInit(): void {
        this.getUserData()
            .subscribe(value => {
                this.userData.set(value);
            });
    }

    private getUserData() {
        return this.userDataResource.getUserData();
    }

    getCurrent(): Observable<UserData> {
        if (!this.userData()) {
            return this.getUserData()
                .pipe(
                    tap(e => this.userData.set(e))
                );
        }
        return of(this.userData());
    }
}
